import axios from 'axios';

const ROOT = 'api/v1/site-patient';

const PatientDetailsApi = {
  getPatientDetails(ssuPatientId, hideLoader = false) {
    return axios.get(`${ROOT}/${ssuPatientId}/details`, { hideLoader });
  }
};

export default PatientDetailsApi;
